/*
 * @Description: 油款发票 store
 * @Author: lijinpeng
 * @Date: 2022-10-21 16:36:14
 * @LastEditTime: 2023-09-19 14:47:41
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getSalesReceiptList, getOilAvailableAmount } from '@/api/invoice';

const storeModuleName = 'oilInvoiceModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: false, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '申请时间',
        prop: 'apply_time',
        width: 90,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-applyTime',
      },
      {
        label: '申请金额',
        prop: 'money',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-money',
      },
      {
        label: '申请状态',
        prop: 'status_name',
        width: 110,
        checked: 1,
        sortable: true,
      },
      {
        label: '货物类型',
        prop: 'category',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '开票方',
        prop: 'party',
        width: 85,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-party',
      },
      {
        label: '发票抬头',
        prop: 'invoice',
        width: 85,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-invoice',
      },
      {
        label: '快递信息',
        prop: 'express',
        width: 135,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-express',
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  availableAmount: 0, // 可开发票金额
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    var oilInvoiceListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      oilInvoiceListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    localStorage.setItem('oilInvoiceListHabits', JSON.stringify(oilInvoiceListHabits));
    // 获取可开发票金额信息
    context.dispatch('getAmount');
    const { data } = await getSalesReceiptList({
      corpId: params.businessId,
      pageNo: context.state.postParams.page,
      pageSize: context.state.postParams.size,
    });
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  getAmount: async context => {
    const { code, data } = await getOilAvailableAmount({
      corpId: context.state.parameters[0].value,
    });
    if (code === 200) {
      context.commit('updateState', {
        key: 'availableAmount',
        value: data.totalUnInvoicedOilAmount,
      });
    }
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('oilInvoiceListHabits');
          localStorage.setItem(
            'oilInvoiceListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
